
import "../../styles/widgets/widgets.css";

export function LoadingAnimation() {
    return <div className="loading-anim">
        <div></div>
        <div></div>
        <div></div>
    </div>
};

export function ProgressIcon() {
    return <div className="progressIcon"></div>;
}